<template>
  <v-container id="user-profile" fluid tag="section">
    <base-material-card icon="mdi-map-marker-path" :title="id
      ? $i18n.t('Trip') +
      '# ' +
      trip.tripNo +
      (trip.invoice_id ? ' - ' + $i18n.t('Invoiced') : '')
      : $i18n.t('Create Trip')
      " v-if="trip" class="my-0 small-icon" color="primary">
      <v-btn style="position: absolute; right: 0px; top: -15px; color: black" x-small color="grey lighten-3"
        v-if="trip.createdBy">Created By : {{ trip.createdBy }} |
        {{ trip.createdAt | moment("HH:mm DD MMM YYYY") }}</v-btn>
      <v-btn style="position: absolute; right: 300px; top: -15px; color: black" x-small color="grey lighten-3"
        v-if="trip.updateBy">Updated By : {{ trip.updateBy }} |
        {{ trip.updatedAt | moment("HH:mm DD MMM YYYY") }}</v-btn>
      <v-row style="position: absolute; top: 5px; right: 10px; width: 70%">
        <v-col cols="12" sm="12" md="8" lg="8"><progress-wizard :status="wizardStatus" :trip="trip"
            @startStopDialogClose="startStopDialogClose" v-if="id" style="
              background: transparent;
              font-size: 10px;
              height: 20px;
              width: 100%;
            "></progress-wizard></v-col>
      </v-row>

      <v-form id="form" v-if="trip">
        <v-card>
          <v-card-text class="py-0">
            <v-row>
              <!-- <v-col cols="12" md="3">
                <z-client-select
                  v-model="trip.corp_id"
                  :owner_id="trip.vendor_id"
                  withSelf
                  @input="fetchAppliedTaxSlab"
                  @resetVendorEntity="resetVendorEntity"
                />
              </v-col>

              <v-col cols="12" md="3" v-if="trip.corp_id">
                <z-entity-select
                  :corp="trip.corp_id"
                  v-model="trip.clientEntity_id"
                  @input="fetchAppliedTaxSlab"
                  :label="$i18n.t('Client Entity')"
                  @fullEntity="fullClientEntity"
                  autoSelect
                />
              </v-col> -->

              <v-col cols="12" md="3" v-if="trip.vendor_id">
                <z-entity-select :corp="trip.vendor_id" v-model="trip.vendorEntity_id" :label="$i18n.t('Serving Entity')"
                  @input="fetchAppliedTaxSlab" autoSelect @fullEntity="fullvendorEntity" />
              </v-col>

              <v-col cols="12" md="3">
                <z-tag-select v-model="trip.tags" :multiple="true" :kind="4" />
              </v-col>

              <v-col cols="12" sm="12" md="4" lg="4">
                <z-name-master-select v-model="trip.zone_id" :label="'Zone'" :type="13" :id="true"
                  :addNewLabel="'Add New Zone'" />
                <!-- <z-zone-select v-model="trip.zone_id"/> -->
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="my-3">
          <v-card-text class="py-0">
            <v-row>
              <v-col cols="12" md="2">
                <z-date-picker :label="$i18n.t('Pickup Date')" v-model="trip.startTime" timestamp />
              </v-col>
              <v-col cols="12" md="2">
                <z-time-picker :label="$i18n.t('Pickup Time')" v-model="trip.startTime" timestamp="trip.startTime" />
              </v-col>
              <v-col cols="12" md="2" v-if="trip.status < 4">
                <z-time-picker :label="$i18n.t('Pickup Till')" v-model="trip.startTill" />
              </v-col>
              <!-- <v-col cols="12" md="2" v-if="trip.status > 3">
                <z-date-picker
                  v-model="trip.pod.receivedDate"
                  :label="$i18n.t('Received Date')"
                />
              </v-col> -->
              <v-col cols="12" md="2" v-if="trip.status > 3">
                <z-date-picker :label="$i18n.t('Reporting Date')" v-model="trip.reportingDate" />
              </v-col>
              <v-col cols="12" md="2" v-if="trip.status > 3">
                <z-date-picker :label="$i18n.t('Delivery Date')" v-model="trip.deliveryDate" />
              </v-col>
              <!-- <v-col cols="12" md="2">
                <z-time-picker
                  :label="
                    trip.status > 3
                      ? $i18n.t('Delivery Time')
                      : $i18n.t('Drop Time')
                  "
                  v-model="trip.dropFrom"
                />
              </v-col> -->
              <!-- <v-col cols="12" md="2" v-if="trip.status < 6">
                <z-time-picker
                  :label="$i18n.t('Deliver Till')"
                  v-model="trip.dropTill"
                />
              </v-col> -->
              <v-col cols="12" md="2" v-if="trip.status > 5">
                <z-date-picker :label="$i18n.t('Unloading Date')" v-model="trip.endTime" timestamp />
              </v-col>
              <!-- <v-col cols="12" md="2">
                <z-vehicle-type-select
                  categories="true"
                  v-model="trip.truckType"
                />
              </v-col> -->
            </v-row>
          </v-card-text>
        </v-card>

        <cargos v-model="trip" @addNewEmptyCargo="addNewEmptyCargo" @reload="closeDialog" @reloadError="reloadError"
          :errors="errors" />

        <v-card class="my-3">
          <v-card-title class="subtitle-1 card-title-head">
            {{
              id
              ? $i18n.t("Vehicle") + "/" + $i18n.t("Driver")
              : $i18n.t("Vehicle")
            }}

            <span v-if="!expand.vd" style="margin-left: 30px"><v-icon>mdi-car</v-icon>
              {{ trip.vehicle ? trip.vehicle.regNo : "" }}
              {{
                trip.vehicle ? "( " + trip.vehicle.vehicleTypeStr + " )" : ""
              }}</span>
            <span v-if="!expand.vd" style="margin-left: 30px"><v-icon>mdi-steering</v-icon>
              {{ trip.driver ? trip.driver.name : "" }}
              {{
                trip.driver
                ? "( " +
                trip.driver.countryCode +
                " " +
                trip.driver.phone +
                " )"
                : ""
              }}</span>
          </v-card-title>
          <v-expand-transition>
            <v-card-text class="py-0 text-body-1">
              <v-row>
                <v-col cols="12" md="2">
                  <z-name-master-select :hideAddNew="true" v-model="trip.bodyType" :label="'Body Type'" :type="10" />
                </v-col>


                <v-col cols="12" md="4">
                  <vehicle :trip="trip" :bodyType="trip.bodyType" :truckType="trip.truckType"
                    @setAdhocVehicle="setVehicleData" @unassignVehicle="unassignVehicle" @input="onVehicleChange">
                  </vehicle>
                </v-col>

                <v-col cols="12" md="2">
                  <z-vehicle-type-select categories="true" v-model="trip.truckType" :bodyType="trip.bodyType" />
                </v-col>

                <v-col cols="12" md="4">
                  <driver :trip="trip" @setAdhocDriver="setDriverData" @unassignDriver="unassignDriver"
                    @input="onDriverChange"></driver>
                </v-col>
              </v-row>
            </v-card-text>
          </v-expand-transition>
        </v-card>

        <!-- <billing-fare
          v-model="clientBilling"
          v-if="trip.corp_id && trip.vendor_id && $ha('750&107')"
          :vehicleType="trip.truckType"
          :trip="trip"
          :appliedTaxSlab="appliedTaxSlab"
          :myCorp_id="trip.myCorp_id"
          :recalculateFare="recalculateFare"
        /> -->

        <!-- <fare-collection
          v-if="trip.corp_id && trip.vendor_id && trip._id && $ha('750&107')"
          :billing="clientBilling"
          :trip="trip"
          :hideInvoices="true"
          @reload="closeDialog"
        /> -->

        <!-- <v-card
          class="my-3"
          v-if="trip.corp_id && trip.vendor_id && $ha('750&108')"
        > -->
        <v-card class="my-3"
          v-if="trip.clientCargos && trip.clientCargos[0] && trip.clientCargos[0].client_id && trip.vendor_id && $ha('750&108')">
          <v-card-title class="title card-title-head" @click="expand = !expand">
            <v-icon v-if="expand">mdi-chevron-right</v-icon>
            <v-icon v-if="!expand">mdi-chevron-down</v-icon>
            {{ $i18n.t("Supplier Charges") }}
            <v-spacer />
            <v-btn x-small fab text color="light-blue" class="float-right" @click="addNewSupplierBilling">

              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-card-title>
          <v-expand-transition>
            <div v-if="!expand">
              <v-card-text class="py-1" v-for="(bill, i) in trip.billings" :key="'billing' + i">
                <billing-fare v-if="bill.vendor_id == null || bill.vendor_id != trip.myCorp_id" :value="bill"
                  :vehicleType="trip.truckType" :trip="trip" :appliedTaxSlab="appliedTaxSlab" :myCorp_id="trip.myCorp_id"
                  @removeBill="removeBill" :index="i" :forSupplier="true" :recalculateFare="recalculateFare" />
              </v-card-text>
            </div>
          </v-expand-transition>
        </v-card>

        <misc-expense v-if="trip && $ha(750)" :trip="trip"> </misc-expense>

        <v-card class="my-3" v-if="id && trip.status > 3">
          <v-card-title class="subtitle-1 card-title-head"
            @click="expand.pod ? (expand.pod = false) : (expand.pod = true)">
            <v-icon v-if="!expand.pod">mdi-chevron-right</v-icon>
            <v-icon v-if="expand.pod">mdi-chevron-down</v-icon>
            {{ $i18n.t("Proof of Delivery") }} /
            {{ $i18n.t("POD") }}
            <v-chip-group column v-if="!expand.pod" style="margin-left: 30px">
              <v-chip small color="blue" dark v-if="trip.pod.receivedDate"><v-icon>mdi-check-all</v-icon>{{
                $i18n.t("POD Received")
              }}</v-chip>

              <v-chip small color="green" dark v-if="trip.pod.submitDate"><v-icon>mdi-check</v-icon>{{
                $i18n.t("POD Submitted")
              }}</v-chip>

              <v-chip small color="red" dark v-if="!trip.pod.submitDate && !trip.pod.receivedDate">
                <v-icon>hourglass_empty</v-icon>{{

                  $i18n.t("POD Pending")

                }} </v-chip>

            </v-chip-group>
          </v-card-title>
          <v-expand-transition>
            <v-card-text class="py-0 text-body-1" v-if="expand.pod">
              <v-row>
                <v-col cols="12" sm="4" md="3" lg="2">
                  <v-row>
                    <z-date-picker v-model="trip.pod.receivedDate" :label="$i18n.t('Received Date')" />
                  </v-row>
                  <v-row>
                    <z-date-picker v-model="trip.pod.submitDate" :label="$i18n.t('Submitted Date')" />
                  </v-row>
                </v-col>
                <v-col cols="12" sm="8" md="9" lg="10">
                  <v-row>
                    <v-col cols="12" sm="4" md="3" lg="2" v-for="(picture, index) in trip.pod.attachments" :key="index">
                      <v-card>
                        <z-confirm-button fab color="red" x-small class="image-remove"
                          :message="$i18n.t('Remove Image ?')" @click="removePODAttachment(picture.time)">
                          <v-icon>mdi-trash-can-outline</v-icon>
                        </z-confirm-button>
                        <a :href="picture.url">
                          <v-img v-if="isPDF(picture.url)" src="@/assets/pdf_format.png" aspect-ratio="2"
                            class="grey darken-4"></v-img>
                          <v-img v-else :src="picture.url" aspect-ratio="2" class="grey darken-4"></v-img>
                        </a>
                        <v-row class="px-2">
                          <v-col cols="12" md="12" lg="12">
                            {{ picture.time | moment("HH:mm DD MMM YYYY") }}
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="3" md="1" lg="1" style="margin-top: 14px">
                      <z-upload-file-dialog :requestURL="'/api/trip/' + trip._id + '/pod/attachment/upload'
                        " @closeDialog="closeDialog" btn>
                        <v-btn color="blue" x-small>
                          {{ $i18n.t("Upload Proof") }}
                        </v-btn>
                      </z-upload-file-dialog>
                    </v-col>
                  </v-row>
                </v-col>

              </v-row>
            </v-card-text>
          </v-expand-transition>
        </v-card>

        <v-card class="my-3" v-if="id">
          <v-card-title class="subtitle-1 card-title-head"
            @click="expand.tnc ? (expand.tnc = false) : (expand.tnc = true)">
            <v-icon v-if="!expand.tnc">mdi-chevron-right</v-icon>
            <v-icon v-if="expand.tnc">mdi-chevron-down</v-icon>
            {{ $i18n.t("Terms & Conditions")
            }}<v-btn color="cyan" style="float: right" x-small fab text class="bill-right-headers"
              @click="showAddContent = true">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-card-title>
          <v-expand-transition>
            <v-card-text class="py-0 text-body-1" v-if="expand.tnc">
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <div v-html="tripTnC" class="text-size" />
                </v-col>
              </v-row>
            </v-card-text>
          </v-expand-transition>
        </v-card>

        <v-card class="my-3" v-if="id">
          <v-card-title class="subtitle-1 card-title-head" @click="expand.hel = true">
            <v-icon v-if="!expand.hel">mdi-chevron-right</v-icon>
            <v-icon v-if="expand.hel">mdi-chevron-down</v-icon>
            {{ $i18n.t("Helpers") }}<v-spacer />

            <v-col clos="12" md="6">
              <v-btn @click="
                trip.helpers.push({
                  name: null,
                  countryCode: 91,
                  phone: null,
                });
              expand.hel = true;
              " small style="width: 60px; float: right" color="light-blue" text>
                <v-icon>mdi-plus</v-icon>
                <h3>{{ $i18n.t("Add") }}</h3>
              </v-btn>
              <z-driver-select btn="true" :helper="true" fab text class="purple-input float-right"
                :label="$i18n.t('Helper Select')" @input="onHelperSelect">
                <v-btn small text>
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </z-driver-select>
            </v-col>
          </v-card-title>
          <v-expand-transition>
            <v-card-text class="py-0 text-body-1" v-if="expand.hel">
              <v-row dense style="padding: 10px" v-for="(item, index) in trip.helpers" :key="'helper' + index">
                <v-col cols="12" md="4">
                  <v-text-field v-model="item.name" :label="$i18n.t('Name')" />
                </v-col>
                <v-col cols="12" md="4">
                  <v-row>
                    <v-col cols="12" md="4">
                      <z-country-select isd hideName hideFlag v-model="item.countryCode" :label="$i18n.t('Code')" />
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field :label="$i18n.t('Phone')" v-model="item.phone" type="number" maxlength="12"
                        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="4">
                  <v-btn class="float-right" color="error" small fab text dark
                    @click="remove(trip.helpers, index, false)">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-expand-transition>
        </v-card>

        <v-card class="my-3" v-if="id">
          <v-card-title class="subtitle-1 card-title-head" @click="expand.com = !expand.com">
            <v-icon v-if="!expand.com">mdi-chevron-right</v-icon>
            <v-icon v-if="expand.com">mdi-chevron-down</v-icon>

            {{ $i18n.t("Comments") }}<v-spacer />
            <v-btn text fab style="width: 60px; float: right" small v-if="trip._id" color="blue lighten-2"
              :title="$i18n.t('Add Comment')" @click="showCommentDialog = true">

              <v-icon>mdi-plus </v-icon>
              <h3>{{ $i18n.t("Add") }}</h3>
            </v-btn>

          </v-card-title>
          <v-expand-transition>
            <v-card-text class="py-0 text-body-1" v-if="expand.com">
              <all-comments :comments="trip.comments" />
            </v-card-text>
          </v-expand-transition>
        </v-card>

        <v-card class="my-3" v-if="id">
          <v-card-title class="subtitle-1 card-title-head" @click="expand.doc = !expand.doc">
            <v-icon v-if="!expand.doc">mdi-chevron-right</v-icon>
            <v-icon v-if="expand.doc">mdi-chevron-down</v-icon>
            {{ $i18n.t("Documents") }}<v-spacer />
            <z-upload-file-dialog :requestURL="'/api/trip/' + trip._id + '/uploadDoc'
              " @closeDialog="closeDialog" btn>
              <v-btn text fab style="width: 60px; float: right" small v-if="trip._id" color="blue lighten-2"
                :title="$i18n.t('Upload Document')">
                <v-icon>mdi-plus </v-icon>
                <h3>{{ $i18n.t("Upload") }}</h3>
              </v-btn>
            </z-upload-file-dialog>
          </v-card-title>
          <v-card-text>
            <div v-if="trip.docs && trip.docs.length > 0">
              <ul>
                <li v-for="(doc, i) in trip.docs" :key="i"
                  style="margin-bottom: 10px; display: flex; justify-content: space-between; align-items: center;">
                  <div style="display: inline;">
                    <span style="font-weight: bold;">{{ "File " + (i + 1) + " - " }}</span>
                    <a :href="doc.url" target="_blank"
                      style="text-decoration: none; color: #007bff; white-space: nowrap;">{{ doc.name }}</a>
                  </div>
                  <div v-if="doc.time" style="display: inline;">
                    <z-confirm-button class="float-right" color="red lighten-1" x-small fab text
                      :message="$i18n.t('Do you want to delete this Document ?')"
                      @click="handleDocRemove(doc.time, trip._id)">
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </z-confirm-button>
                    <!-- <v-btn
                      text
                      @click="handleDocRemove(doc.time, trip._id)"
                      style="display: inline; cursor: pointer; background-color: transparent; border: none;"
                    >
                      <span>{{ $i18n.t("Delete") }}</span>
                    </v-btn> -->
                  </div>
                </li>
              </ul>
            </div>
          </v-card-text>
        </v-card>

        <v-row class="mr-2 mt-2 ms-3">
          <v-btn color="secondary" small fab text dark :to="'/trip'">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <z-confirm-button text fab small color="red lighten-2" :title="$i18n.t('Cancel Trip')" @click="cancelTrip()"
            :message="$i18n.t('Do you want to cancel this trip ?')" v-if="trip.showCancel">
            <v-icon>mdi-cancel</v-icon>
          </z-confirm-button>
          <z-confirm-button text fab small color="red lighten-2" :title="$i18n.t('Delete Trip')" @click="deleteTrip()"
            :message="$i18n.t('Do you want to cancel this trip ?')" v-if="trip.showDelete">
            <v-icon>mdi-trash-can-outline</v-icon>
          </z-confirm-button>

          <v-btn text fab small color="teal lighten-2" :title="$i18n.t('Mark Completed')" @click="markCompleted()"
            v-if="trip.showMarkCompleted && trip.showSave">
            <v-icon>mdi-gavel</v-icon>
          </v-btn>

          <v-btn text fab small :color="trip.status == 3
            ? 'blue lighten-2'
            : trip.status == 4
              ? 'red lighten-2'
              : trip.status == 5
                ? 'red accent-3'
                : 'purple'
            " :title="$i18n.t('Update Trip Details')" @click="showStartStopDialog = true"
            v-if="trip.status > 2 && trip.showSave && copy == true">
            <v-icon v-if="trip.status == 3">mdi-play</v-icon>
            <v-icon v-if="trip.status == 4 || trip.status == 5">mdi-play-pause</v-icon>
            <v-icon v-if="trip.status != 3 && trip.status != 4 && trip.status != 5">mdi-check-all</v-icon>
          </v-btn>

          <v-btn text fab small color="teal lighten-2" :title="$i18n.t('Audit Logs')" @click="showAuditLog = true"
            v-if="trip.showAuditLog">
            <v-icon>mdi-database</v-icon>
          </v-btn>
          <!-- <v-btn
            text
            fab
            small
            color="grey"
            :title="$i18n.t('Create Invoice')"
            @click="createInvoiceDialog()"
            v-if="trip.showMakeInvoice"
          >
            <v-icon>mdi-receipt</v-icon>
          </v-btn> -->
          <v-btn text fab small v-if="trip._id" color="blue lighten-2" :title="$i18n.t('Add Comment')"
            @click="showCommentDialog = true">
            <v-icon>mdi-comment-multiple </v-icon>
          </v-btn>
          <!-- <v-menu
            v-if="
              trip.showPrintInvoice ||
                trip.showInvoice ||
                trip.showInvCreate ||
                trip.showInvVerify ||
                trip.showInvSubmit ||
                trip.showInvDelete
            "
          >
            <template v-slot:activator="{ on }">
              <v-btn text fab v-on="on" color="green" small>
                <v-icon>mdi-receipt</v-icon>
              </v-btn>
            </template>
            <v-list v-if="trip.showInvoice">
              <v-btn
                text
                target="_blank"
                :to="'/sales/invoice/' + trip.invoice_id"
                ><v-icon>mdi-eye</v-icon> {{ $i18n.t("Show Invoice") }}</v-btn
              >
            </v-list>
            <v-list v-if="trip.showInvoice">
              <v-btn text @click="recreateInvoice()"
                ><v-icon>mdi-refresh</v-icon>{{ $i18n.t("Recreate") }}</v-btn
              >
            </v-list>
            <v-list v-if="trip.showInvoice">
              <v-btn text @click="invEmail()"
                ><v-icon>mdi-email</v-icon>{{ $i18n.t("Email Invoice") }}</v-btn
              >
            </v-list>
            <v-list v-if="trip.showInvCreate">
              <v-btn text @click="changeInvoiceStatus(0)"
                ><v-icon>mdi-exclamation-thick</v-icon
                >{{ $i18n.t("Mark Unverified") }}</v-btn
              >
            </v-list>
            <v-list v-if="trip.showInvVerify">
              <v-btn text @click="changeInvoiceStatus(1)"
                ><v-icon>mdi-check</v-icon>{{ $i18n.t("Mark Verified") }}</v-btn
              >
            </v-list>
            <v-list v-if="trip.showPrintInvoice">
              <v-btn text @click="invDownload()"
                ><v-icon>mdi-printer</v-icon>
                {{ $i18n.t("Print Invoice") }}</v-btn
              >
            </v-list>
            <v-list v-if="trip.showInvDelete">
              <z-confirm-button
                text
                :title="$i18n.t('Delete Trip')"
                @click="deleteInvoice()"
                :message="$i18n.t('Do you want to cancel this trip ?')"
              >
                <v-icon>mdi-trash-can-outline</v-icon>
                {{ $i18n.t("Delete Invoice") }}
              </z-confirm-button>
            </v-list>
          </v-menu> -->
          <v-spacer />
          <!-- <v-btn color="success" @click="copiedTripPage()" v-if="copy&&this.$route.params.id!=null" :loading="loading">
            <h3>{{ $i18n.t("Copy") }}</h3>
          </v-btn > -->
          <v-btn color="success" @click="saveDelay()" v-if="trip.showSave" :loading="loading">
            <h3>{{ $i18n.t("Save") }}</h3>
          </v-btn>
        </v-row>
      </v-form>
    </base-material-card>

    <v-dialog v-model="vehicleUpdate" color="white" width="400">
      <v-card>
        <v-card-text>{{ vehicleUpdateText }}</v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="green" text small @click="onVehicleUpdateYes(true)" v-if="driverUpdate" :loading="loading">
            <span>{{ $i18n.t("To Trip Only") }}</span>
          </v-btn>
          <v-btn color="green" text small @click="onVehicleUpdateYes(false)" v-if="driverUpdate" :loading="loading">
            <span>{{ $i18n.t("To Vehicle") }}</span>
          </v-btn>
          <v-btn color="green" text small @click="onVehicleUpdateYes()" v-if="!driverUpdate" :loading="loading">
            <v-icon>mdi-check</v-icon>
          </v-btn>
          <v-btn color="red" text fab small v-bind="attrs" @click="onVehicleUpdateNo()" :loading="loading">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <CargoSelect :dialog="showCargoSelect" @input="addNewCargo" />
    <duty-close :trip="trip" :showDialog="showDutyCloseDialog" @dutyCloseDilogClose="dutyCloseDilogClose" />
    <trip-start-stop :trip="trip" :showSSDialog="showStartStopDialog" @startStopDialogClose="startStopDialogClose" />
    <z-invoice-download :payload="payload" :showDialog="showInvoiceDoanload" @closeDialog="closeDialog" :isMail="isMail"
      :invoice="invForMail"></z-invoice-download>
    <z-invoice-create :filters="finalFilters" :showDialog="showCreateInvoice" :selctedTrips="selctedTrips"
      @closeDialog="closeDialog" />
    <add-comment :showCommentDialog="showCommentDialog" @closeCommentDialog="closeCommentDialog"
      @comment="returnedComment" />
    <v-dialog v-model="showAddContent" transition="dialog-top-transition">
      <v-card>
        <v-toolbar dark color="secondary" fixed class="sticky-top">
          <v-toolbar-title>
            <v-icon>mdi-card-text</v-icon>
            {{ $i18n.t("Add/Edit Content") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="showAddContent = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <static-content-edit :payload="{
            corp_id: trip ? trip.vendor_id : null,
            contentType: 'TRIP_TNC',
            fromDialog: true,
          }" @fetchContent="fetchTripPolicyContent()" @contentDialog="onContentDialogChange()" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <z-audit-log v-if="trip" :showDialog="showAuditLog" :entity_id="trip._id" entity="Trip"
      @closeAuditLog="showAuditLog = false">
    </z-audit-log>

    <save-button :header="'Save Trip'" :msg="tripErrMsg" :tripSaveDialog="preSaveDialog" @preSave="preSave">
    </save-button>
  </v-container>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet, doPost, doGetWithDownload } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import CargoSelect from "@/views/trip/CargoSelect.vue";
import BillingFare from "@/views/trip/BillingFare.vue";
import { CommonUtil } from "@/js/commonUtil";
import DutyClose from "@/views/trip/DutyClose";
import StaticContentEdit from "@/views/staticcontent/StaticContentEdit.vue";
import ProgressWizard from "@/views/trip/ProgressWizard.vue";
import FareCollection from "@/views/trip/FareCollection.vue";
import TripStartStop from "@/views/trip/TripStartStop.vue";
import MiscExpense from "@/views/trip/MiscExpense.vue";
import Vehicle from "@/views/trip/Vehicle.vue";
import Driver from "@/views/trip/Driver.vue";
import SaveButton from "@/views/trip/SaveButton.vue";
import AllComments from "@/views/comment/AllComments.vue";
import AddComment from "@/views/comment/AddComment.vue";
import CorpService from "@/store/common/module/CorpService";
import Cargos from "@/views/trip/Cargos.vue";

@Component({
  name: "TripEdit",
  props: {
    value: {
      default: null,
    },
    createInvoicePayload: {
      default: null,
    },
  },
  components: {
    CargoSelect,
    BillingFare,
    DutyClose,
    TripStartStop,
    StaticContentEdit,
    ProgressWizard,
    FareCollection,
    MiscExpense,
    Vehicle,
    Driver,
    AllComments,
    AddComment,
    SaveButton,
    Cargos,
  },
})
export default class TripEdit extends Vue {
  trip = null;
  attrs = null;
  showCargoSelect = false;
  driverUpdate = false;
  tripTnC = null;
  showAddContent = false;
  wizardStatus = null;
  showAuditLog = false;
  rate = {};
  id = null;
  vehicleUpdate = false;
  vehicleUpdateText = "Confirm Vehicle Update";
  oldVeh = null;
  appliedTaxSlab = null;
  recalculateFare = null;
  showDutyCloseDialog = false;
  showStartStopDialog = false;
  showCreateInvoice = false;
  createInvoiceType = "selected";
  selctedTrips = [];
  finalFilters = {};
  payload = {};
  invForMail = null;
  isMail = null;
  showCreateInvoice = null;
  showInvoiceDoanload = null;
  expand = { lr: null, pod: true, vd: true, tnc: null, hel: null, com: true, doc: false };
  taxList = [];
  vehicleSupplier_id = null;
  driverSupplier_id = null;
  vehicleCreateDialog = null;
  driverCreateDialog = null;
  showCommentDialog = null;
  preSaveDialog = null;
  tripErrMsg = "";
  errors = {};

  isPDF(_url) {
    if (_url && _url.includes(".pdf")) {
      return true;
    }
    return false;
  }

  closeDialog(reload) {
    this.showCreateInvoice = false;
    this.showInvoiceDoanload = false;
    this.payload = {};
    this.invForMail = null;
    this.isMail = false;
    if (reload) this.get(this.id);
  }

  async returnedComment(comment) {
    const data = {};
    data.message = comment.msg;
    data.commentsFor = comment.commentsFor;
    await doPost("/api/trip/" + this.trip._id + "/comment/add", data);
    this.expand.com = true;
    this.closeCommentDialog();
    this.get(this.id);
  }

  closeCommentDialog() {
    this.showCommentDialog = null;
  }

  async setHoldOnComment(comment) {
    if (!this.trip.onHold) this.trip.onHold = {};
    if (!this.trip.onHold.comments) this.trip.onHold.comments = [];
    this.trip.onHold.comments.push(comment);
  }

  onContentDialogChange(value) {
    this.showAddContent = value;
  }

  findBilling(client_id, vendor_id) {
    if (this.trip.billings == null) return null;
    for (const i in this.trip.billings) {
      const billing = this.trip.billings[i];
      if (
        billing != null &&
        billing.client_id != null &&
        billing.vendor_id != null &&
        billing.client_id == client_id &&
        billing.vendor_id == vendor_id
      )
        return billing;
    }
    if (client_id && vendor_id) {
      const bill = {
        client_id: client_id,
        vendor_id: vendor_id,
        fareTariff: { baseFare: null },
        fare: { charges: [], taxes: [], discounts: [] },
      };
      this.trip.billings.push(bill);
      return bill;
    }
    return null;
  }

  // clientBilling = null;

  removeBill(index) {
    if (index != null) {
      this.remove(this.trip.billings, index, null);
    }
  }

  addNewSupplierBilling() {
    const vendor_id =
      this.trip &&
        this.trip.vehicle &&
        this.trip.vehicle.corp_id &&
        this.trip.vehicle.corp_id != this.trip.myCorp_id
        ? this.trip.vehicle.corp_id
        : null;
    const bill = {
      client_id: this.trip.vendor_id,
      vendor_id: vendor_id,
      fareTariff: { baseFare: null },
      fare: {
        charges: [],
        // charges: [{ taxItem: { tax_id: null } }],
        taxes: [],
        discounts: [],
      },
    };

    let tax_id = null;
    if (this.taxList != null) {
      for (let _i = 0; _i < this.taxList.length; _i++) {
        if (this.taxList[_i].name && this.taxList[_i].name.includes("ZERO")) {
          tax_id = this.taxList[_i]._id;
        }
      }
    }

    const charge = {
      taxItem: { tax_id: tax_id },
      discounts: [],
      items: [
        {
          name: "Freight Charge",
          desc: null,
          units: 1,
          unitCost: null,
          amount: null,
        },
      ],
    };
    bill.fare.charges.push(charge);
    this.trip.billings.push(bill);
  }

  get loading() {
    return common.loading;
  }

  async unassignVehicle(trip) {
    if (!this.id) {
      this.trip.vehicle = null;
      return;
    }
    common.setLoading(true);
    try {
      await doGet(`/api/unassign/trip/${trip._id}/vehicle`);
      common.showMessage("Vehicle Unassigned");
      this.get(this.id);
    } catch (e) {
      common.setLoading(false);
      common.setError(e.message);
    }
  }

  async recalulateFare() {
    common.setLoading(true);
    try {
      const fare = await doPost("/api/trip/calc/fare", this.trip);
      if (fare && fare.charges) {
        for (const i in fare.charges) {
          if (!fare.charges[i].taxItem) fare.charges[i].taxItem = {};
          if (!fare.charges[i].discountItem) fare.charges[i].discountItem = {};
        }
      }
      this.trip.fare = fare;
      common.setLoading(false);
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }

  fullTax(taxDetail, item) {
    item.taxDetail = taxDetail;
  }

  fullClientEntity(entity, item) {
    this.trip.clientEntity = {
      details: entity,
    };
  }

  fullvendorEntity(entity, item) {
    this.trip.vendorEntity = {
      details: entity,
    };
  }

  closeVehicleCreateDialog() {
    this.vehicleCreateDialog = null;
  }

  setVehicleData(vehicle) {
    this.trip.vehicle = vehicle;
  }

  setDriverData(driver) {
    this.trip.driver = driver;
  }

  unassignDriver() {
    this.trip.driver = {};
  }

  closeDriverCreateDialog() {
    this.driverCreateDialog = null;
  }

  validateSave() {
    // if (!this.trip.billings || this.trip.billings.length == 0) {
    //   common.setError("Please select rate.");
    //   return false;
    // }
    if (
      this.trip.pod &&
      this.trip.pod.submitDate &&
      !this.trip.pod.receivedDate
    ) {
      common.setError("POD Submitted ! Please select date");
      return false;
    }
    for (const i in this.trip.billings) {
      const billing = this.trip.billings[i];
      if (!billing.vendor_id) {
        common.setError("Please provide suplier in supplier fare.");
        return false;
      }
      if (billing.fare.charges) {
        for (let i = 0; i < billing.fare.charges.length; i++) {
          if (billing.fare.charges[i].items) {
            for (let _i = 0; _i < billing.fare.charges[i].items.length; _i++) {
              if (!billing.fare.charges[i].items[_i].name) {
                common.setError("Please provide name for all charges.");
                return false;
              }
              if (!billing.fare.charges[i].items[_i].amount) {
                common.setError("Please provide amount for all charges.");
                return false;
              }
            }
          }

          if (billing.fare.charges[i].discounts) {
            for (
              let _i = 0;
              _i < billing.fare.charges[i].discounts.length;
              _i++
            ) {
              if (!billing.fare.charges[i].discounts[_i].name) {
                common.setError("Please provide name for all discount.");
                return false;
              }
              if (!billing.fare.charges[i].discounts[_i].amount) {
                common.setError("Please provide amount for all discount.");
                return false;
              }
            }
          }
        }
      }
    }

    // if (this.trip.cargos && this.trip.cargos.length > 0) {
    //   for (let _i = 0; _i < this.trip.cargos.length; _i++) {
    //     const element = this.trip.cargos[_i];
    //     if (element && (!element.lr || !element.lr.number)) {
    //       common.setError("Please provide cargo GRN / LR number");
    //       return false;
    //     }
    //   }
    // }

    if (
      this.trip.miscExpense &&
      this.trip.miscExpense.charges &&
      this.trip.miscExpense.charges.length > 0
    ) {
      for (let _i = 0; _i < this.trip.miscExpense.charges.length; _i++) {
        const element = this.trip.miscExpense.charges[_i];
        if (element && !element.name) {
          common.setError("Please provide expense name");
          return false;
        }
      }
    }

    return true;
  }
  async handleDocRemove(time, id) {
    if (time && id) {
      const url = "/api/trip/" + id + "/" + time + "/deleteDoc";
      common.setLoading(true);
      try {
        await doGet(url);
        this.get(id);
        common.setLoading(false);
        common.showMessage("Deleted Successfully");
      } catch (error) {
        common.setLoading(false);
        common.setError(error.message);
      }
    }
  }

  async save() {
    try {
      if (!this.validateSave()) {
        return;
      }
      common.setLoading(true);
      let url = "/api/trip/save";
      if (this.id) {
        url = "/api/trip/update/get";
      }
      const response = await doPost(url, this.trip);
      if (!this.id) this.$router.push("/trip/" + response._id);
      if (this.copy == false) {
        this.copy = true;
      }
      this.get(response._id);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async preSave(action) {
    this.preSaveDialog = null;
    if (action == true) {
      await this.save();
    }
  }

  async saveDelay() {
    let callSave = true;
    // if (this.trip.cargos && this.trip.cargos.length > 0) {
    //   for (let _i = 0; _i < this.trip.cargos.length; _i++) {
    //     const element = this.trip.cargos[_i];
    //     if (element && (!element.lr || !element.lr.number)) {
    //       this.tripErrMsg = "Cargo GR/LR number not provided. Do you want to generate GR/LR number automatically ?";
    //       callSave = false;
    //     }
    //   }
    // }
    if (this.trip.clientCargos && this.trip.clientCargos.length > 0) {
      for (let _i = 0; _i < this.trip.clientCargos.length; _i++) {
        const clientCargo = this.trip.clientCargos[_i];
        if (clientCargo) {
          if (clientCargo.cargos && clientCargo.cargos.length > 0) {
            for (let _i = 0; _i < clientCargo.cargos.length; _i++) {
              const element = clientCargo.cargos[_i];
              if (element && (!element.lr || !element.lr.number) && callSave) {
                this.tripErrMsg = "Cargo GR/LR number not provided. Do you want to generate GR/LR number automatically ?";
                callSave = false;
              }
            }
          }
        }
      }
    }
    if (callSave == false) {
      this.preSaveDialog = true;
    } else {
      await this.save();
    }
  }

  reload() {
    this.get(this.id);
  }

  async removePODAttachment(_time) {
    try {
      common.setLoading(true);
      await doGet(
        "/api/trip/" + this.id + "/pod/attachment/" + _time + "/delete"
      );
      this.get(this.id);
      common.setLoading(false);
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  prepareWizardStatus(response) {
    this.wizardStatus = null;
    if (response.status == 3) {
      this.wizardStatus = 0;
    }
    if (response.status == 4) {
      this.wizardStatus = 1;
    }
    if (response.status == 6) {
      this.wizardStatus = 2;
    }
    if (response.status == 20) {
      this.wizardStatus = 3;
    }
    if (response.status == 21) {
      this.wizardStatus = 4;
    }
    // if (this.wizardStatus == 2 && response.pod && response.pod.receivedDate) {
    //   this.wizardStatus = 3;
    // }
    // if (
    //   this.wizardStatus == 3 &&
    //   response.pod &&
    //   response.pod.receivedDate &&
    //   response.pod.submitDate
    // ) {
    //   this.wizardStatus = 4;
    // }
    if (
      this.wizardStatus == 4 &&
      response.myCorp_id &&
      response.clientCargos &&
      response.clientCargos.length > 0
    ) {
      for (let i = 0; i < response.clientCargos.length; i++) {
        const bil = response.clientCargos[i].billing;
        let clientNotSettled = true;
        if (bil && bil.vendor_id && bil.vendor_id == response.myCorp_id) {
          if (bil.venInvStatus) {
            const temp = bil.venInvStatus.split("_");
            if (temp && temp.length > 1) {
              const sta = parseInt(temp[1]);
              if (sta == 3) {
                clientNotSettled = false;
              }
            }
          }
          if (bil.fare && bil.fare.pending == 0) {
            clientNotSettled = false;
          }
        }
        if (!clientNotSettled) {
          this.wizardStatus = 5;
        }
      }
    }
  }

  prepareResponseDelete(response) {
    if (!response.dutySlipNo) response.dutySlipNo = null;
    if (!response.zone_id) response.zone_id = null;
    if (response.tariffStructure) {
      if (!response.tariffStructure.others)
        response.tariffStructure.others = [];
      if (!response.tariffStructure.discounts)
        response.tariffStructure.discounts = [];
    }
    if (!response.helpers) response.helpers = [];
    if (!response.dst) response.dst = {};

    if (!response.truckType) response.truckType = null;
    if (!response.bodyType) response.bodyType = null;

    if (!response.vehicle) response.vehicle = {};
    if (!response.driver) response.driver = {};

    if (!response.consignor) response.consignor = {};
    if (!response.consignor.address) response.consignor.address = {};
    if (!response.consignor.address.addressLine)
      response.consignor.address.addressLine = null;
    if (!response.consignor.address.city)
      response.consignor.address.city = null;
    if (!response.consignor.address.state)
      response.consignor.address.state = null;
    if (!response.consignor.address.country)
      response.consignor.address.country = null;
    if (!response.consignor.address.pinCode)
      response.consignor.address.pinCode = null;
    if (!response.consignor.name) response.consignor.name = null;
    if (!response.consignor.gstin) response.consignor.gstin = null;
    if (!response.consignor.email) response.consignor.email = null;
    if (!response.consignor.countryCode) response.consignor.countryCode = null;
    if (!response.consignor.phone) response.consignor.phone = null;

    if (!response.pod) response.pod = {};
    if (!response.pod.receivedDate) response.pod.receivedDate = null;
    if (!response.pod.submitDate) response.pod.submitDate = null;
    if (response.pod.submitDate) response.disablePOD = true;

    if (!response.vendorEntity) response.vendorEntity = {};
    if (!response.clientEntity) response.clientEntity = {};

    if (!response.clientCargos) response.clientCargos = [];
    if (response.clientCargos.length == 0) response.clientCargos.push({});

    if (!response.cargos) response.cargos = [];
    if (response.cargos.length == 0) response.cargos.push({});

    for (let index = 0; index < response.cargos.length; index++) {
      if (!response.cargos[index].consignor)
        response.cargos[index].consignor = {};
      if (!response.cargos[index].consignor.address)
        response.cargos[index].consignor.address = {};
      if (!response.cargos[index].consignor.address.addressLine)
        response.cargos[index].consignor.address.addressLine = null;
      if (!response.cargos[index].consignor.address.city)
        response.cargos[index].consignor.address.city = null;
      if (!response.cargos[index].consignor.address.state)
        response.cargos[index].consignor.address.state = null;
      if (!response.cargos[index].consignor.address.country)
        response.cargos[index].consignor.address.country = null;
      if (!response.cargos[index].consignor.address.pinCode)
        response.cargos[index].consignor.address.pinCode = null;
      if (!response.cargos[index].consignor.name)
        response.cargos[index].consignor.name = null;
      if (!response.cargos[index].consignor.gstin)
        response.cargos[index].consignor.gstin = null;
      if (!response.cargos[index].consignor.email)
        response.cargos[index].consignor.email = null;
      if (!response.cargos[index].consignor.countryCode)
        response.cargos[index].consignor.countryCode = null;
      if (!response.cargos[index].consignor.phone)
        response.cargos[index].consignor.phone = null;
      if (!response.cargos[index].material)
        response.cargos[index].material = null;

      if (!response.cargos[index].src) response.cargos[index].src = {};
      if (!response.cargos[index].src.country)
        response.cargos[index].src.country = "India";
      if (!response.cargos[index].src.state)
        response.cargos[index].src.state = null;
      if (!response.cargos[index].src.city)
        response.cargos[index].src.city = null;
      if (!response.cargos[index].src.addressLine)
        response.cargos[index].src.addressLine = null;

      if (!response.cargos[index].dst) response.cargos[index].dst = {};
      if (!response.cargos[index].dst.country)
        response.cargos[index].dst.country = "India";
      if (!response.cargos[index].dst.state)
        response.cargos[index].dst.state = null;
      if (!response.cargos[index].dst.city)
        response.cargos[index].dst.city = null;
      if (!response.cargos[index].dst.addressLine)
        response.cargos[index].dst.addressLine = null;

      if (!response.cargos[index].invBranch)
        response.cargos[index].invBranch = {};
      if (!response.cargos[index].invBranch.address)
        response.cargos[index].invBranch.address = {};

      if (!response.cargos[index].loadAsst)
        response.cargos[index].loadAsst = [];

      if (!response.cargos[index].loadAsst)
        response.cargos[index].loadAsst = [];

      if (!response.cargos[index].lr) response.cargos[index].lr = {};
      if (!response.cargos[index].lr.number)
        response.cargos[index].lr.number = null;
      if (!response.cargos[index].lr.date)
        response.cargos[index].lr.date = null;
      if (!response.cargos[index].lr.wayBillNo)
        response.cargos[index].lr.wayBillNo = null;
      if (!response.cargos[index].lr.invoiceNo)
        response.cargos[index].lr.invoiceNo = null;
      if (!response.cargos[index].lr.currency)
        response.cargos[index].lr.currency = null;
      if (!response.cargos[index].lr.amount)
        response.cargos[index].lr.amount = null;

      if (!response.cargos[index].lr.insurance)
        response.cargos[index].lr.insurance = {};
      if (!response.cargos[index].lr.insurance.provider)
        response.cargos[index].lr.insurance.provider = null;
      if (!response.cargos[index].lr.insurance.date)
        response.cargos[index].lr.insurance.date = null;
      if (!response.cargos[index].lr.insurance.policyNo)
        response.cargos[index].lr.insurance.policyNo = null;
      if (!response.cargos[index].lr.insurance.risk)
        response.cargos[index].lr.insurance.risk = null;
      if (!response.cargos[index].lr.insurance.currency)
        response.cargos[index].lr.insurance.currency = null;
      if (!response.cargos[index].lr.insurance.amount)
        response.cargos[index].lr.insurance.amount = null;
      if (!response.cargos[index].lr.insurance.insuredAmount)
        response.cargos[index].lr.insurance.insuredAmount = null;

      if (response.cargos[index].lr && response.cargos[index].lr.number) {
        response.cargos[index].showLRDownload = true;
      }
    }

    if (response.fare && response.fare.charges) {
      for (let i = 0; i < response.fare.charges.length; i++) {
        if (!response.fare.charges[i].taxItem)
          response.fare.charges[i].taxItem = {};
        if (!response.fare.charges[i].discountItem)
          response.fare.charges[i].discountItem = {};
        if (response.fare.charges[i].discounts == undefined) {
          response.fare.charges[i].discounts = [];
        }
      }
    }

    if (!response.miscExpense) response.miscExpense = {};
    if (!response.miscExpense.charges) response.miscExpense.charges = [];
    if (!response.miscExpense.total) response.miscExpense.total = null;

    if (!response.onHold) response.onHold = {};
    if (!response.onHold.comments) response.onHold.comments = [];
    if (response.onHold.amount == undefined) response.onHold.amount = null;
    if (response.onHold.status == undefined) response.onHold.status = null;

    this.prepareWizardStatus(response);
  }

  prepareResponse(response) {
    if (!response.dutySlipNo) response.dutySlipNo = null;
    if (!response.zone_id) response.zone_id = null;
    if (response.tariffStructure) {
      if (!response.tariffStructure.others)
        response.tariffStructure.others = [];
      if (!response.tariffStructure.discounts)
        response.tariffStructure.discounts = [];
    }
    if (!response.helpers) response.helpers = [];

    if (!response.truckType) response.truckType = null;
    if (!response.bodyType) response.bodyType = null;

    if (!response.vehicle) response.vehicle = {};
    if (!response.driver) response.driver = {};

    if (!response.pod) response.pod = {};
    if (!response.pod.receivedDate) response.pod.receivedDate = null;
    if (!response.pod.submitDate) response.pod.submitDate = null;
    if (response.pod.submitDate) response.disablePOD = true;

    if (!response.vendorEntity) response.vendorEntity = {};
    if (!response.clientEntity) response.clientEntity = {};

    if (!response.clientCargos) response.clientCargos = [];
    if (response.clientCargos.length == 0) {
      const cargo = {
        material: null,
        src: { country: "India", state: null, city: null, addressLine: null },
        dst: { country: "India", state: null, city: null, addressLine: null },
        consignor: {},
        consignee: {},
        invBranch: { address: {} },
        loadAsst: [],
        unloadAsst: [],
        lr: {
          number: null, wayBillNo: null,
          date: null, invoiceNo: null,
          insurance: { currency: "INR", amount: null }
        },
      };

      const charge = {
        taxItem: {},
        discounts: [],
        items: [
          {
            name: null,
            desc: null,
            units: 1,
            unitCost: null,
            amount: null,
          },
        ],
      };

      charge.items[0].name = "Freight Charge";
      const fare = { charges: [] };
      fare.charges.push(charge);

      const clientCargo = {
        client_id: null,
        clientEntity_id: null,
        billing: { fare: fare },
        cargos: []
      }
      clientCargo.cargos.push(cargo);
      response.clientCargos.push(clientCargo);
    }

    if (response.fare && response.fare.charges) {
      for (let i = 0; i < response.fare.charges.length; i++) {
        if (!response.fare.charges[i].taxItem)
          response.fare.charges[i].taxItem = {};
        if (!response.fare.charges[i].discountItem)
          response.fare.charges[i].discountItem = {};
        if (response.fare.charges[i].discounts == undefined) {
          response.fare.charges[i].discounts = [];
        }
      }
    }

    if (!response.miscExpense) response.miscExpense = {};
    if (!response.miscExpense.charges) response.miscExpense.charges = [];
    if (!response.miscExpense.total) response.miscExpense.total = null;

    if (!response.onHold) response.onHold = {};
    if (!response.onHold.comments) response.onHold.comments = [];
    if (response.onHold.amount == undefined) response.onHold.amount = null;
    if (response.onHold.status == undefined) response.onHold.status = null;
    if (!response.docs) response.docs = [];

    this.prepareWizardStatus(response);
  }

  async get(id) {
    common.setLoading(true);
    try {
      this.recalculateFare = null;
      const response = await doGet("/api/trip/" + id + "/get");
      common.setLoading(false);
      setTimeout(() => {
        this.recalculateFare = true;
      }, 14000);
      this.prepareResponse(response);
      this.fetchAppliedTaxSlab();
      this.trip = response;
      if (this.copy == false) {
        this.processTripForCopy();
      }

      if (this.copy == true) {
        this.id = this.trip._id;
      }

      this.fetchTaxes();
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }

    this.reloadError(true, "");
  }

  async reloadError(reload, val) {
    if (reload && this.trip && this.trip._id) {
      try {
        this.errors = await doGet("/api/trip/" + this.trip._id + "/errors?invNo=" + val);
      } catch (e) {
        common.setLoading(false);
      }
    }
  }

  async getNewTrip() {
    try {
      common.setLoading(true);
      const response = await doGet("/api/trip/new");
      setTimeout(() => {
        this.recalculateFare = true;
      }, 7000);
      this.prepareResponse(response);
      this.fetchAppliedTaxSlab();
      this.trip = response;
      this.fetchTaxes();
      common.setLoading(false);
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async fetchTaxes() {
    if (!this.taxList || this.taxList.length < 1) {
      await CorpService.populateTaxes(this.trip.myCorp_id);
      this.taxList = CorpService.taxes[this.trip.myCorp_id];
    }
  }

  async fetchTripPolicyContent() {
    this.tripTnC = await doGet("/api/static/content/render/TRIP_TNC");
  }

  async mounted() {
    this.mountedV2();
  }
  async mountedV2() {
    await this.$root.$on("event.trip.reload", (reload) => {
      if (reload) {
        this.get(this.$route.params.id);
      }
    });
    if (this.$route.params.id && !this.$route.query.forCopy) {

      await this.get(this.$route.params.id);
    } else if (this.$route.params.id && this.$route.query.forCopy) {
      this.copy = false;
      await this.get(this.$route.params.id);
    }
    else {
      this.getNewTrip();
    }
    await this.fetchTripPolicyContent();
  }
  copy = true;
  copiedTripPage() {
    if (this.$route.params.id) {
      this.$router.push("/trip/" + this.$route.params.id + "?forCopy=true");
      /*  window.location.reload(); */
      this.mountedV2();
    }

  }

  processTripForCopy() {
    if (this.trip) {
      if (this.trip._id) {
        this.id = null;

        this.trip._id = null;
        this.trip.tripNo = null;
        this.trip.showMarkCompleted = false;
        this.trip.createdAt = null;
        this.trip.createdBy = null;
        this.trip.updateBy = null;
        this.trip.updatedAt = null;
        this.trip.createdByCorp = null;
        this.trip.cancelledBy = null;
        this.trip.showSave = true
        this.trip.showDelete = false;
        this.trip.showCloseDuty = false;
        this.trip.showCancel = false;
        this.trip.showAuditLog = false;
        this.trip.showPrintInvoice = false;
        this.trip.showInvoice = false;
        this.trip.showInvVerify = false;
        this.trip.showInvSubmit = false;
        this.trip.showInvDelete = false;
        this.trip.invoice_id = null;
        this.trip.startKm = null;
        this.trip.endKm = null;
        this.trip.status = 0;
        this.trip.clientInvoice_id = null;

        if (this.trip.cargos && this.trip.cargos.length > 0) {
          for (let i = 0; i < this.trip.cargos.length; i++) {
            this.trip.cargos[i].lr.number = null;
            this.trip.cargos[i].lr.clientNo = null;
          }
        }

        if (this.trip.fare) {
          this.trip.fare.amountPaid = 0;
          this.trip.fare.pending = this.trip.fare.subTotal
        }

        if (this.trip.billings && this.trip.billings.length > 0) {
          for (let i = 0; i < this.trip.billings.length; i++) {
            if (this.trip.billings[i].venInvStatus != null || this.trip.billings[i].venInvStatus != "") {
              this.trip.billings[i].venInvStatus = this.trip.billings[i].venInvStatus.trim();
              const arr = this.trip.billings[i].venInvStatus.split("_");
              if (arr && arr.length == 2) {
                this.trip.billings[i].venInvStatus = arr[0] + "_-1";
              }
            }
            this.trip.billings[i].invoice_id = null;
          }
        }
        if (this.trip.clientBilling) {

          this.trip.clientBilling.invoice_id = null;
        }
      }
    }
  }

  addCargo() {
    this.showCargoSelect = true;
  }

  addNewEmptyCargo() {
    const cargo = {
      material: null,
      client: null,
      src: { country: "India", state: null, city: null, addressLine: null },
      dst: { country: "India", state: null, city: null, addressLine: null },
      invBranch: { address: {} },
      loadAsst: [],
      unloadAsst: [],
      lr: { insurance: { currency: "INR" } },
    };
    this.trip.cargos.push(cargo);
  }

  // @Watch("trip.corp_id")
  // onClientChange(corp_id) {
  //   if (this.clientBilling == null && corp_id) {
  //     this.clientBilling = this.findBilling(corp_id, this.trip.vendor_id);
  //   }
  //   this.clientBilling.client_id = corp_id;
  // }

  @Watch('trip', { immediate: true, deep: true })
  consoleWatch() {
    // console.log(this.trip);
  }
  resetVendorEntity(entity_id) {
    this.trip.vendorEntity_id = entity_id;
  }

  async fetchAppliedTaxSlab() {
    let url = "/api/invoice/create/get/tax/slab?";
    if (this.trip && this.trip.vendorEntity_id && this.trip.clientEntity_id) {
      url =
        url +
        "&vendor_id=" +
        this.trip.vendor_id +
        "&clientEntity_id=" +
        this.trip.clientEntity_id +
        "&vendorEntity_id=" +
        this.trip.vendorEntity_id +
        "&client_id=" +
        this.trip.corp_id +
        "&forIndividual=false";
      try {
        this.appliedTaxSlab = await doGet(url);
      } catch (e) {
        console.log(e);
      }
    }
  }

  addNewCargo(cargo) {
    this.showCargoSelect = false;
    if (cargo) {
      let found = false;
      if (this.trip.cargos && this.trip.cargos.length > 0) {
        for (let i = 0; i < this.trip.cargos.length; i++) {
          if (this.trip.cargos[i]._id == cargo._id) {
            found = true;
          }
        }
      }
      if (!found) this.trip.cargos.push(cargo);
    }
  }

  async onRateSelect(rate) {
    if (rate) {
      if (rate.tariffStructure) {
        if (!rate.tariffStructure.others) rate.tariffStructure.others = [];
        if (!rate.tariffStructure.discounts)
          rate.tariffStructure.discounts = [];
      }
      this.trip.tariffStructure = rate.tariffStructure;
      this.trip.vehicleType = rate.tariffStructure.vehicleType;
      this.recalulateFare();
    }
  }

  async onVehicleUpdateYes(toTripOnly) {
    common.setLoading(true);
    try {
      if (!this.driverUpdate) {
        if (!this.trip.vehicle && this.oldVeh) {
          //This means vehicle is removed by clearable in dropdown
          this.unassignVehicle(this.trip);
          return;
        } else {
          await doGet(
            "/api/assign/trip/" +
            this.trip._id +
            "/vehicle/" +
            this.trip.vehicle._id
          );
        }
      } else {
        let url = "";
        if (toTripOnly) {
          url =
            "/api/trip/" +
            this.trip._id +
            "/driver/" +
            this.trip.driver._id +
            "/assign";
        } else {
          url =
            "/api/trip/" +
            this.trip._id +
            "/driver/" +
            this.trip.driver._id +
            "/assign/vehicle/" +
            this.trip.vehicle._id;
        }
        await doGet(url);
      }
      this.vehicleUpdate = false;
      this.get(this.id);
      common.showMessage("Vehicle/Driver Assigned.");
    } catch (e) {
      common.setLoading(false);
      common.setError(e.message);
    }
  }

  calculateFare() {
    CommonUtil.calculateFare(
      this.trip,
      this.trip.vendorEntity,
      this.trip.clientEntity,
      this.appliedTaxSlab
    );
    // this.calulateTotalFare();
  }

  onVehicleChange(newVal) {
    if (!this.id) {
      const oldVal = this.trip.vehicle;
      //No popup if and api call if trip is not saved
      // console.log(newVal);
      this.trip.vehicle = newVal;
      if (newVal.driver_id) {
        this.trip.driver = {
          _id: newVal.driver_id,
          // "driverOf" : newVal.,
          // "pic" : newVal.,
          countryCode: newVal.driverCC,
          phone: newVal.driverPhone,
          name: newVal.driverName,
          // "corpName" : newVal.,
        };
      }
      this.oldVeh = oldVal;
      return;
    }
    const oldVal = this.trip.vehicle;
    this.driverUpdate = false;
    this.vehicleUpdate = true;
    if (newVal == null && oldVal != null) {
      this.vehicleUpdateText = this.$i18n.t(
        "Confirm vehicle to be unassigned !"
      );
    }
    if (newVal != null && oldVal == null) {
      this.vehicleUpdateText = this.$i18n.t("Confirm vehicle assignment !");
    }
    if (newVal != null && oldVal != null) {
      this.vehicleUpdateText = this.$i18n.t("Confirm vehicle replace !");
    }
    this.oldVeh = oldVal;
    this.trip.vehicle = newVal;
  }

  onHelperSelect(newVal) {
    if (newVal) {
      this.trip.helpers.push(newVal);
    }
  }

  onDriverChange(newVal) {
    if (!this.id) {
      //No popup if and api call if trip is not saved
      this.trip.driver = newVal;
      return;
    }
    const oldVal = this.trip.driver;
    this.vehicleUpdate = true;
    this.driverUpdate = true;
    if (newVal == null && oldVal != null) {
      this.vehicleUpdateText = this.$i18n.t(
        "Confirm driver to be unassigned !"
      );
    }
    if (newVal != null && oldVal == null) {
      this.vehicleUpdateText = this.$i18n.t("Confirm driver assignment !");
    }
    if (newVal != null && oldVal != null) {
      this.vehicleUpdateText = this.$i18n.t("Confirm driver replace !");
    }
    this.oldVeh = oldVal;
    this.trip.driver = newVal;
  }

  onVehicleUpdateNo() {
    this.vehicleUpdate = false;
    this.trip.vehicle = this.oldVeh;
  }

  newItem(itemList) {
    if (!itemList) itemList = [];
    itemList.push({});
    return itemList;
  }
  remove(list, _index, calcFare) {
    list.splice(_index, 1);
    if (calcFare) this.calculateFare();
  }

  async cancelTrip() {
    const data = { trip_id: this.trip._id };
    try {
      common.setLoading(true);
      await doPost("/api/trip/mark/cancelled", data);
      this.get(this.id);
      common.setLoading(false);
    } catch (e) {
      common.setLoading(false);
      common.setError(e.message);
    }
  }

  async deleteTrip() {
    try {
      common.setLoading(true);
      await doGet("/api/trip/" + this.trip._id + "/delete");
      this.get(this.id);
      common.showMessage("Trip Deleted");
      common.setLoading(false);
    } catch (e) {
      common.setLoading(false);
      common.setError(e.message);
    }
  }

  markCompleted() {
    this.showDutyCloseDialog = true;
  }

  dutyCloseDilogClose(reload) {
    if (reload) this.get(this.id);
    this.showDutyCloseDialog = false;
  }

  startStopDialogClose(reload) {
    if (reload) this.get(this.id);
    this.showStartStopDialog = false;
  }

  createInvoiceDialog() {
    const _payload = {};
    _payload.vendor_id = this.trip.vendor_id;
    _payload.client_id = this.trip.corp_id;
    _payload.clientEntity_id = this.trip.clientEntity_id;
    _payload.vendorEntity_id = this.trip.vendorEntity_id;
    _payload.invoiceType = 2;
    _payload.trips = [];
    _payload.trips.push(this.trip);

    if (!_payload) {
      common.setError("Please select parameters");
      return;
    }
    if (!_payload.client_id) {
      common.setError("Client not provided");
      return;
    }
    if (!_payload.vendor_id) {
      common.setError("Vendor not provided");
      return;
    }
    if (!_payload.invoiceType) {
      common.setError("Type not provided");
      return;
    }
    if (!_payload.trips) {
      common.setError("Select trips");
      return;
    }
    const finalFilters = {};
    finalFilters.client_id = _payload.client_id;
    finalFilters.vendor_id = _payload.vendor_id;
    finalFilters.invoiceType = _payload.invoiceType;
    finalFilters.clientEntity_id = _payload.clientEntity_id;
    finalFilters.vendorEntity_id = _payload.vendorEntity_id;
    this.selctedTrips = _payload.trips;
    this.finalFilters = finalFilters;
    this.showCreateInvoice = true;
  }

  invEmail() {
    this.invForMail = {
      //TODO change if supplier invoiced
      _id: this.invoice_id,
      client_id: this.corp_id,
      clientEntity_id: this.clientEntity_id,
      vendor_id: this.vendor_id,
      vendorEntity_id: this.vendorEntity_id,
    };
    this.isMail = true;
    this.showInvoiceDoanload = true;
  }

  invDownload() {
    const _invoice = {
      //TODO change if supplier invoiced
      _id: this.trip.invoice_id,
      client_id: this.trip.corp_id,
      clientEntity_id: this.trip.clientEntity_id,
      vendor_id: this.trip.vendor_id,
      vendorEntity_id: this.trip.vendorEntity_id,
    };
    let ids = "";
    const clients = [];
    let vendor_id, client_id, vendorEntity_id, clientEntity_id;
    let v_consider = true;
    let c_consider = true;
    let vEntity_consider = true;
    let cEntity_consider = true;
    if (_invoice) {
      ids += _invoice._id;
      clients.push(_invoice.client_id);
      vendor_id = _invoice.vendor_id;
      client_id = _invoice.client_id;
      vendorEntity_id = _invoice.vendorEntity_id;
      clientEntity_id = _invoice.clientEntity_id;
    } else {
      this.grid.rows.forEach(function (t) {
        if (t.selected) {
          ids += t._id + ",";
          clients.push(t.client_id);
          if (v_consider) {
            if (vendor_id == null) {
              vendor_id = t.vendor_id;
            } else if (vendor_id != t.vendor_id) {
              v_consider = false;
            }
          }
          if (c_consider) {
            if (client_id == null) {
              client_id = t.client_id;
            } else if (client_id != t.client_id) {
              c_consider = false;
            }
          }
          if (vEntity_consider) {
            if (vendorEntity_id == null) {
              vendorEntity_id = t.vendorEntity._id;
            } else if (vendorEntity_id != t.vendorEntity._id) {
              vEntity_consider = false;
            }
          }
          if (cEntity_consider) {
            if (clientEntity_id == null) {
              clientEntity_id = t.clientEntity._id;
            } else if (clientEntity_id != t.clientEntity._id) {
              cEntity_consider = false;
            }
          }
        }
      });
    }

    if (!ids) {
      common.setError("Please select invoice(s) to download PDF/Excel");
      return false;
    }

    const payload = { invoice_ids: ids, client_ids: clients };
    if (v_consider) {
      payload.vendor_id = vendor_id;
    }
    if (c_consider) {
      payload.client_id = client_id;
    }
    if (vEntity_consider) {
      payload.vendorEntity_id = vendorEntity_id;
    }
    if (cEntity_consider) {
      payload.clientEntity_id = clientEntity_id;
    }
    this.payload = payload;
    this.showInvoiceDoanload = true;
  }

  async changeInvoiceStatus(status) {
    if (status != null && status != undefined && this.trip.invoice_id) {
      try {
        common.setLoading(true);
        await doGet(
          "/api/invoice/" +
          this.trip.invoice_id +
          "/status/" +
          status +
          "/update"
        );
        this.get(this.id);
        common.showMessage("Updated");
        common.setLoading(false);
      } catch (e) {
        common.setLoading(false);
        common.setError(e);
      }
    }
  }

  async recreateInvoice() {
    if (this.trip.invoice_id) {
      try {
        common.setLoading(true);
        await doGet("/api/invoice/" + this.trip.invoice_id + "/recreate");
        this.get(this.id);
        common.showMessage("Updated");
        common.setLoading(false);
      } catch (e) {
        common.setLoading(false);
        common.setError(e);
      }
    }
  }

  async deleteInvoice() {
    if (this.trip.invoice_id) {
      try {
        common.setLoading(true);
        await doGet("/api/invoice/" + this.trip.invoice_id + "/delete");
        this.get(this.id);
        common.showMessage("Updated");
        common.setLoading(false);
      } catch (e) {
        common.setLoading(false);
        common.setError(e);
      }
    }
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}

.v-text-field__details {
  display: none;
}

.v-input input[type="number"] {
  text-align: right !important;
}

.dense tr td {
  padding: 0 3px !important;
}

.image-remove {
  position: absolute;
  z-index: 1;
  text-transform: none;
  color: red;
  top: 4px;
  right: -12px;
  font-size: 12px;
}

.card-title-head {
  background-color: rgb(211, 235, 240);
  height: 40px;
  padding-top: 0px;
  color: #3b7776;
}
</style>
